import { orderBy } from 'lodash';
import { createSelector } from 'reselect';
import { RootState } from '../root.reducer';

export const selectMoneyCategories = createSelector(
    (state: RootState) => Object.values(state.moneyCategories),
    (moneyCategories: any) => orderBy(moneyCategories, 'name')
)
